import { Grid, Typography, Divider, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

const TextDivider = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Grid
      container
      alignItems="center"
      sx={{
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
      }}
    >
      <Grid item xs={5}>
        <Divider />
      </Grid>
      <Grid item xs={2}>
        <Typography
          sx={{
            color: theme.palette.grey[400],
            [theme.breakpoints.down('sm')]: { fontSize: 12 },
          }}
          align="center"
        >
          {t('general:or').toUpperCase()}
        </Typography>
      </Grid>
      <Grid item xs={5}>
        <Divider />
      </Grid>
    </Grid>
  );
};

export default TextDivider;
